import Card, { CardProps } from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { fade } from '@material-ui/core/styles/colorManipulator'
import * as React from 'react'

import Avatar from '../avatar/Avatar'
import Typography from '../base/Typography'
import Icon, { IconList, IconsProps } from '../icons/Icons'

export type ServiceTypeCardProps = {
  isSelected: boolean
  onClick(): void
  iconName: keyof typeof IconList
  label: string
  className?: string
  iconProps?: Partial<IconsProps>
  cardProps?: Partial<CardProps>
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardRoot: {
      color: theme.palette.primary.main,
      width: 156,
      boxShadow: 'none',
      position: 'relative',
      overflow: 'visible'
    },
    default: {
      border: `1px solid ${theme.palette.grey[600]}`,
      background: theme.palette.common.white
    },
    selected: {
      border: `1px solid ${theme.palette.secondary.main}`,
      background: fade(theme.palette.secondary.main, 0.06)
    },
    cardActionAreaRoot: {
      padding: 24,
      flex: 1,
      textAlign: 'center'
    },
    avatarRoot: {
      position: 'absolute',
      top: -8,
      right: -8,
      background: theme.palette.secondary.main
    },
    typographyRoot: {
      marginTop: 8
    }
  })
)

const ServiceTypeCard: React.FC<ServiceTypeCardProps> = (props) => {
  const {
    isSelected,
    onClick,
    iconName,
    label,
    iconProps,
    cardProps,
    className
  } = props
  const classes = useStyles()

  let Button
  if (isSelected) {
    Button = (
      <Avatar className={classes.avatarRoot} customSize="small">
        <Icon iconName="TickIcon" size="small" />
      </Avatar>
    )
  }

  return (
    <Card
      {...cardProps}
      classes={{ root: classes.cardRoot }}
      className={`ServiceTypeCard ${
        isSelected ? classes.selected : classes.default
      } ${className}`}
    >
      {Button}
      <CardActionArea
        onClick={(): void => {
          onClick()
        }}
        classes={{ root: classes.cardActionAreaRoot }}
      >
        <Icon iconName={iconName} size="extraLarge" {...iconProps} />
        <Typography className={classes.typographyRoot} bodyVariants="lgMedium">
          {label}
        </Typography>
      </CardActionArea>
    </Card>
  )
}

export default ServiceTypeCard
